import React from 'react';
import PropTypes from 'prop-types';

import { Avatar } from '@mssgme/ui';

import styles from './Contact.scss';

Contact.propTypes = {
    name: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
};

export default function Contact({ name, avatarUrl, children, ...rest }) {
    return (
        <figure className={styles.root} {...rest}>
            <Avatar className={styles.avatar} name={name} src={avatarUrl} size={36} />
            <figcaption className={styles.caption}>
                <div className={styles.contactName}>{name}</div>
                {children}
            </figcaption>
        </figure>
    );
}
